/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import{LexicalBuilder as e}from"@lexical/extension/LexicalBuilder";function n(n,r){const o=e.fromEditor(n).getExtensionRep(r);return void 0===o&&function(e,...n){throw function(e,...n){const r=new URL("https://lexical.dev/docs/error"),o=new URLSearchParams;o.append("code",e);for(const e of n)o.append("v",e);return r.search=o.toString(),new Error(`Minified Lexical error #${e}; visit ${r.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`)}(e,...n)}(303,r.name),o.getExtensionDependency()}export{n as getExtensionDependencyFromEditor};
